import { Box, Link } from '@mui/material';
import React from 'react';
import { StyledTypography } from '../styles/styles';

export function FAQViewContactFooter() {
  return (
    <Box sx={{ mt: 6, textAlign: 'center' }}>
      <StyledTypography tone="default" fontSize="1rem" sx={{ color: 'text.secondary', mb: 2 }}>
        Can't find what you're looking for?
      </StyledTypography>
      <StyledTypography tone="default" fontSize="1rem" sx={{ color: 'text.secondary' }}>
        Contact us at{' '}
        <Link
          href="mailto:enquires@fidescapital.com.au"
          sx={{
            color: 'primary.main',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          enquires@fidescapital.com.au
        </Link>{' '}
        for additional assistance.
      </StyledTypography>
    </Box>
  );
}
